import { render } from "./App.vue?vue&type=template&id=8ad499f2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8ad499f2&lang=css"

import exportComponent from "H:\\Takahammas\\website\\takahammas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__